import React, { useState, useEffect, useCallback } from "react";
import { CancelRequest } from "../../../services/AxiosInstance";
import Pagination from "../../constant/Pagination";
import { connect } from "react-redux";
import TableLoaderEffect from "../../constant/TableLoader";
import DebounceSearchInput from "../../constant/DebounceSearchInput";
import { getDivisionListApi } from "../../../services/DivisonService";
import AddDivision from "./AddDivision";
import EditDivision from "./EditDivision";

const DivisionPage = ({ userRole }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState("");
    const [data, setData] = useState([]);
    const [query, setSearchQuery] = useState("");
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const recordsPage = 25;



    const fetchData = useCallback(() => {
        CancelRequest();
        setIsLoading(true);
        getDivisionListApi(currentPage, recordsPage, query)
            .then((resp) => {
                setData(resp.data.data);
                setTotal(resp.data.total);
            })
            .catch((error) => {
                console.error(error.response?.data?.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [currentPage, query]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);



    const handlePagination = (page) => {
        setCurrentPage(page.selected + 1);
    };

    const handleSearchChange = (value) => {
        if (value.length > 0) CancelRequest();
        setFilter((prev) => ({
            ...prev,
            query: value,
        }));
        setCurrentPage(1);
    };

    const handleAfterCreate = () => {
        setTotal((prevTotal) => prevTotal + 1);
        setCurrentPage(1);
        fetchData();
    };


    const handleAfterUpdate = (updatedData) => {
        setData((prevData) =>
            prevData.map((item) =>
                item.id === updatedData.id ? { ...item, ...updatedData } : item
            )
        );
    };

    const handleAfterDelete = (id) => {
        setData((prevData) => prevData.filter((item) => item.id !== id));
        setTotal((prevTotal) => prevTotal - 1);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-6">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-header">
                                <h3 className="mb-0">Division List</h3>
                                <div className="table-left-header">
                                    <div className="form-group me-3">
                                        <DebounceSearchInput
                                            handleSearchChange={handleSearchChange}
                                        />
                                    </div>
                                    <AddDivision handleAfterCreate={handleAfterCreate} />
                                </div>
                            </div>

                            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                <table
                                    id="empoloyees-tblwrapper"
                                    className="table ItemsCheckboxSec dataTable no-footer mb-0"
                                >
                                    <thead>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Name</th>
                                            <th>Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            <TableLoaderEffect colLength={3} />
                                        ) : data.length > 0 ? (
                                            data.map((item, index) => (
                                                <tr key={index}>
                                                    <td><span className="text-primary">{index + 1}</span></td>
                                                    <td>
                                                        <span className="text-primary me-3 c-pointer">{item?.name}</span>
                                                    </td>
                                                    <td>
                                                        <EditDivision
                                                            divisionData={item}
                                                            handleAfterUpdate={handleAfterUpdate}
                                                            handleAfterDelete={handleAfterDelete}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3} className="text-center">
                                                    No divisions found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>

                            {isLoading ? (
                                <div style={{ height: "4rem" }}></div>
                            ) : (
                                <Pagination
                                    currentPage={currentPage}
                                    recordsPage={recordsPage}
                                    dataLength={total}
                                    handlePagination={handlePagination}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-header">
                                <h3 className="mb-0">News List</h3>
                                <div className="table-left-header">
                                    <div className="form-group me-3">
                                        <DebounceSearchInput
                                            handleSearchChange={handleSearchChange}
                                        />
                                    </div>
                                    <AddDivision handleAfterCreate={handleAfterCreate} />
                                </div>
                            </div>

                           

                            {isLoading ? (
                                <div style={{ height: "4rem" }}></div>
                            ) : (
                                <Pagination
                                    currentPage={currentPage}
                                    recordsPage={recordsPage}
                                    dataLength={total}
                                    handlePagination={handlePagination}
                                />
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};
const mapStateToProps = (state) => ({
    userRole: state.auth.user?.role || "Visitor",
});
export default connect(mapStateToProps)(DivisionPage);

